module.exports = __webpack_public_path__ + "img/dark.88a81192.png";